import React, { useState } from 'react';
import LookupAutocomplete from '../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete';
import LabeledField from '../../InquiryRotationView/InquirySchemeManagement/components/LabeledField';
import { useTranslation } from 'react-i18next';
import { PaymentPlansLocalePath } from '../i18n/PaymentPlansLocale';
import IOSSwitch from '../../InquiryRotationView/InquirySchemeManagement/components/IOSSwitch';
import { Button, FormControlLabel } from '@material-ui/core';
import { Inputs } from '../../../../Components';
import { Add } from '@material-ui/icons';
import Joi from 'joi';
import { getErrorByName, showError } from '../../../../Helper';
import { useKeyGenerator } from '../../../../Hooks/keyGenerator';

const feeItem = () => ({
  feeTypeId: null,
  feeType: '',
  feeAmount: null,
  isFixed: false,
  id: crypto.randomUUID(),
});
const AdditionalFeesItem = ({ dispatch }) => {
  const [fee, setFee] = useState(feeItem);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [key, refresh] = useKeyGenerator();
  const { t } = useTranslation(PaymentPlansLocalePath);
  const schema = Joi.object({
    feeTypeId: Joi.number()
      .required()
      .messages({
        'any.required': t('field_is_required', {
          ns: 'Shared',
          field: t('fee_type'),
        }),
      }),
    feeAmount: Joi.number()
      .min(0)
      .required()
      .when('isFixed', { is: false, then: Joi.number().min(0).max(100) })
      .messages({
        'any.required': t('field_is_required', {
          ns: 'Shared',
          field: t('amount'),
        }),
        'number.min': t('valueMustBePositive'),
        'number.max': t('value_less_than_100'),
      }),
    isFixed: Joi.boolean(),
  }).validate(fee, { abortEarly: false, allowUnknown: true });
  const onAddHandler = () => {
    setIsSubmitted(true);
    if (schema.error) {
      showError(t('please-fix-all-errors', { ns: 'Shared' }));
      return;
    }
    dispatch({ field: 'paymentPlanFees', value: fee });
    setFee(feeItem());
    setIsSubmitted(false);
    refresh();
  };
  return (
    <div key={key}>
      <LabeledField
        hideDivider
        component={
          <LookupAutocomplete
            label={t('fee_type')}
            lookupName={'FeeType'}
            selectedValues={
              fee.feeTypeId
                ? {
                    lookupItemId: fee.feeTypeId,
                    lookupItemName: fee.feeType,
                  }
                : null
            }
            onChange={(e, newValue) =>
              setFee((prevFee) => ({
                ...prevFee,
                feeTypeId: newValue.lookupItemId,
                feeType: newValue.lookupItemName,
              }))
            }
            withError
            error={getErrorByName(schema, 'feeTypeId').error}
            helperText={getErrorByName(schema, 'feeTypeId').message}
            isSubmitted={isSubmitted}
          />
        }
      />
      <LabeledField
        component={
          <FormControlLabel
            control={<IOSSwitch />}
            label={t('by_percentage')}
            labelPlacement='end'
            checked={!fee.isFixed}
            onChange={(e, checked) => {
              setFee((prevFee) => ({ ...prevFee, isFixed: !checked }));
            }}
          />
        }
      />
      <LabeledField
        component={
          <Inputs
            labelValue={t('amount')}
            type={'number'}
            startAdornment={
              !fee.isFixed && <span className='start-adornment'>%</span>
            }
            error={getErrorByName(schema, 'feeAmount').error}
            value={fee.feeAmount}
            helperText={getErrorByName(schema, 'feeAmount').message}
            isWithError
            isSubmitted={isSubmitted}
            onInputChanged={(e) => {
              e.persist();
              setFee((prevFee) => ({
                ...prevFee,
                feeAmount: +e.target.value,
              }));
            }}
          />
        }
      />
      <LabeledField
        hideDivider
        component={
          <Button
            className=' capitalize flex gap-2 my-2'
            onClick={onAddHandler}
          >
            {' '}
            <Add />
            <span>{t('add_fee')}</span>
          </Button>
        }
      />
    </div>
  );
};
export default AdditionalFeesItem;
